/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamPracticeAvailabilityResponseCourseId } from './oralExamPracticeAvailabilityResponseCourseId';
import type { OralExamPracticeAvailabilityResponseModuleId } from './oralExamPracticeAvailabilityResponseModuleId';
import type { OralExamPracticeAvailabilityResponseTaskId } from './oralExamPracticeAvailabilityResponseTaskId';
import type { OralExamPracticeAvailabilityResponseSessionId } from './oralExamPracticeAvailabilityResponseSessionId';
import type { OralExamPracticeAvailabilityResponseBookingId } from './oralExamPracticeAvailabilityResponseBookingId';
import type { OralExamPracticeAvailabilityResponseSlotId } from './oralExamPracticeAvailabilityResponseSlotId';
import type { OralExamPracticeAvailabilityResponseReason } from './oralExamPracticeAvailabilityResponseReason';

/**
 * Whether the logged-in student can start the tenant practice exam.
 */
export interface OralExamPracticeAvailabilityResponse {
  available: boolean;
  courseId?: OralExamPracticeAvailabilityResponseCourseId;
  moduleId?: OralExamPracticeAvailabilityResponseModuleId;
  taskId?: OralExamPracticeAvailabilityResponseTaskId;
  sessionId?: OralExamPracticeAvailabilityResponseSessionId;
  bookingId?: OralExamPracticeAvailabilityResponseBookingId;
  slotId?: OralExamPracticeAvailabilityResponseSlotId;
  reason?: OralExamPracticeAvailabilityResponseReason;
}
